import _isFinite from 'lodash/isFinite';
import _reject from 'lodash/reject';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED,
  CPM_GET_CARPARK_METRICS_ACCESSES,
  CPM_GET_CARPARK_METRICS_REVENUES,
  CPM_GET_CARPARK_METRICS_REVENUES_REPORT,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import {
  deserializeOccupancyLive, deserializeOccupancyPeriod,
  deserializeAccesses, deserializeRevenues,
} from '../../../models/cpm/metric';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkMetric;
const cpmCarparkMetric = (state = initialSettings, action) => {
  let metrics;
  let parkingCategoryId;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          occupancy: { ...initialSettings.occupancy },
          access: { ...initialSettings.access },
          revenue: { ...initialSettings.revenue },
        };
      }
      return state;
    // OCCUPANCY_LIVE
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE:
      parkingCategoryId = action.cbParams.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          live: {
            ...state.occupancy.live,
            error: null,
            loading: true,
            global: _isFinite(parkingCategoryId) ? state.occupancy.live.global : null,
            parkingCategories: _isFinite(parkingCategoryId)
              ? _reject(state.occupancy.live.parkingCategories, ['parkingCategoryId', parkingCategoryId])
              : [...state.occupancy.live.parkingCategories],
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE}_ERROR`:
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          live: {
            ...state.occupancy.live,
            error: action.error,
            loading: false,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE}_SUCCESS`:
      // metrics if an object like:
      // {
      //   rate
      // }
      metrics = deserializeOccupancyLive(action.data.metricsLiveOccupancyRate);
      parkingCategoryId = action.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          live: {
            ...state.occupancy.live,
            error: null,
            loading: false,
            global: _isFinite(parkingCategoryId) ? { ...state.occupancy.live.global } : { ...metrics },
            parkingCategories: _isFinite(parkingCategoryId)
              ? [..._reject(state.occupancy.live.parkingCategories, ['parkingCategoryId', parkingCategoryId]), { ...metrics, parkingCategoryId }]
              : [...state.occupancy.live.parkingCategories],
          },
        },
      };
    // OCCUPANCY_PERIOD
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD:
      parkingCategoryId = action.cbParams.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          period: {
            ...state.occupancy.period,
            error: null,
            loading: true,
            global: _isFinite(parkingCategoryId) ? state.occupancy.period.global : null,
            parkingCategories: _isFinite(parkingCategoryId)
              ? _reject(state.occupancy.period.parkingCategories, ['parkingCategoryId', parkingCategoryId])
              : [...state.occupancy.period.parkingCategories],
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD}_ERROR`:
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          period: {
            ...state.occupancy.period,
            error: action.error,
            loading: false,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD}_SUCCESS`:
      metrics = deserializeOccupancyPeriod(action.data.metricsPeriodOccupancyRate);
      parkingCategoryId = action.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          period: {
            ...state.occupancy.period,
            error: null,
            loading: false,
            global: _isFinite(parkingCategoryId) ? state.occupancy.period.global : { periods: [...metrics] },
            parkingCategories: _isFinite(parkingCategoryId)
              ? [..._reject(state.occupancy.period.parkingCategories, ['parkingCategoryId', parkingCategoryId]), { parkingCategoryId, periods: [...metrics] }]
              : [...state.occupancy.period.parkingCategories],
          },
        },
      };
    // CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED:
      parkingCategoryId = action.cbParams.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          predicted: {
            ...state.occupancy.predicted,
            error: null,
            loading: true,
            global: _isFinite(parkingCategoryId) ? state.occupancy.predicted.global : null,
            parkingCategories: _isFinite(parkingCategoryId)
              ? _reject(state.occupancy.predicted.parkingCategories, ['parkingCategoryId', parkingCategoryId])
              : [...state.occupancy.predicted.parkingCategories],
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED}_ERROR`:
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          predicted: {
            ...state.occupancy.predicted,
            error: action.error,
            loading: false,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED}_SUCCESS`:
      metrics = deserializeOccupancyPeriod(action.data.metricsPredictedOccupancy);
      parkingCategoryId = action.parkingCategoryId;
      return {
        ...state,
        occupancy: {
          ...state.occupancy,
          predicted: {
            ...state.occupancy.predicted,
            error: null,
            loading: false,
            global: _isFinite(parkingCategoryId) ? state.occupancy.predicted.global : { periods: [...metrics] },
            parkingCategories: _isFinite(parkingCategoryId)
              ? [..._reject(state.occupancy.predicted.parkingCategories, ['parkingCategoryId', parkingCategoryId]), { parkingCategoryId, periods: [...metrics] }]
              : [...state.occupancy.predicted.parkingCategories],
          },
        },
      };

    // ACCESS_PERIOD
    case CPM_GET_CARPARK_METRICS_ACCESSES:
      parkingCategoryId = action.cbParams.parkingCategoryId;
      return {
        ...state,
        access: {
          ...state.access,
          period: {
            ...state.access.period,
            error: null,
            loading: true,
            global: _isFinite(parkingCategoryId) ? state.access.period.global : null,
            parkingCategories: _isFinite(parkingCategoryId)
              ? _reject(state.access.period.parkingCategories, ['parkingCategoryId', parkingCategoryId])
              : [...state.access.period.parkingCategories],
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_ACCESSES}_ERROR`:
      return {
        ...state,
        access: {
          ...state.access,
          period: {
            ...state.access.period,
            error: action.error,
            loading: false,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_ACCESSES}_SUCCESS`:
      metrics = deserializeAccesses(action.data.metricsAccesses);
      parkingCategoryId = action.parkingCategoryId;
      return {
        ...state,
        access: {
          ...state.access,
          period: {
            ...state.access.period,
            error: null,
            loading: false,
            global: _isFinite(parkingCategoryId) ? state.access.period.global : { periods: [...metrics] },
            parkingCategories: _isFinite(parkingCategoryId)
              ? [..._reject(state.access.period.parkingCategories, ['parkingCategoryId', parkingCategoryId]), { parkingCategoryId, periods: [...metrics] }]
              : [...state.access.period.parkingCategories],
          },
        },
      };
    // REVENUE_PERIOD
    case CPM_GET_CARPARK_METRICS_REVENUES:
      parkingCategoryId = action.cbParams.parkingCategoryId;
      return {
        ...state,
        revenue: {
          ...state.revenue,
          period: {
            ...state.revenue.period,
            error: null,
            loading: true,
            global: _isFinite(parkingCategoryId) ? state.revenue.period.global : null,
            parkingCategories: _isFinite(parkingCategoryId)
              ? _reject(state.revenue.period.parkingCategories, ['parkingCategoryId', parkingCategoryId])
              : [...state.revenue.period.parkingCategories],
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_REVENUES}_ERROR`:
      return {
        ...state,
        revenue: {
          ...state.revenue,
          period: {
            ...state.revenue.period,
            error: action.error,
            loading: false,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_REVENUES}_SUCCESS`:
      metrics = deserializeRevenues(action.data.metricsRevenues);
      parkingCategoryId = action.parkingCategoryId;
      return {
        ...state,
        revenue: {
          ...state.revenue,
          period: {
            ...state.revenue.period,
            error: null,
            loading: false,
            global: _isFinite(parkingCategoryId) ? state.revenue.period.global : { periods: [...metrics] },
            parkingCategories: _isFinite(parkingCategoryId)
              ? [..._reject(state.revenue.period.parkingCategories, ['parkingCategoryId', parkingCategoryId]), { parkingCategoryId, periods: [...metrics] }]
              : [...state.revenue.period.parkingCategories],
          },
        },
      };
    // REVENUE_REPORT
    case CPM_GET_CARPARK_METRICS_REVENUES_REPORT:
      return {
        ...state,
        revenue: {
          ...state.revenue,
          report: {
            ...state.revenue.report,
            error: null,
            loading: true,
            uri: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_REVENUES_REPORT}_ERROR`:
      return {
        ...state,
        revenue: {
          ...state.revenue,
          report: {
            ...state.revenue.report,
            error: action.error,
            loading: false,
            uri: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_METRICS_REVENUES_REPORT}_SUCCESS`:
      return {
        ...state,
        revenue: {
          ...state.revenue,
          report: {
            ...state.revenue.report,
            error: null,
            loading: false,
            uri: action.data.generateInvoiceExport.uri,
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkMetric;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkMetric.js